"use strict";

angular.module("core")
.service("PaymentMethodsService", function($resource, $http, appConfig) {
    this.getMethodChoicesLocalized = function() {
        return $resource(
            appConfig.API_SERVER + "/payment-methods/method-choices/translations/", {}, {get: {method: "GET"}}
        ).get();
    };

    this.getPreAuthorizedPaymentMissingCount = function() {
        return $http.get(appConfig.API_SERVER + "/payment-methods/customer/pre-authorized-payment-missing-agreement/");
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/payment-methods.service.js
// module id = 440
// module chunks = 0